import { initializeFilterDropdown } from "./filter-dropdown";

/** Finds all auto-initializable filter dropdowns, and initializes them. */
htmx.onLoad(rootElement => {
  rootElement.querySelectorAll<HTMLElement>("[data-filter-dropdown]").forEach(element => {
    if (element.dataset.autoInit !== "false") {
      initializeFilterDropdown(element);
    }
  });
});
